import moment from 'moment'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Home = (props) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        setIsLoggedIn(false)
        const localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
        console.log(localuser)
        if(localuser.token){
            // const expiryMoment = moment.unix(localuser.exp)
            // const nowMoment = moment(new Date())
            // const result = nowMoment.isBefore(expiryMoment)
    
            setIsLoggedIn(true)
            navigate('/admin/dashboard')
            // if(result){
            // }else{
            //     navigate('/admin/login')
            // }
        }else{
            navigate('/admin/login')
        }

    }, [])

    // if(isLoggedIn){
    //     navigate('/dashboard')
    // }else{
    //     navigate('/admin/login')
    // }

    return(
        <>
            <p>Loading...</p>
        </>
    )
}

export default Home